export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah M.',
      role: 'Owner, Fresh Market Grocery',
      content: 'Green Choice Bag has been our go-to supplier for over two years. The quality is consistently excellent, and our customers love the eco-friendly packaging. The custom printing really helps our brand stand out.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/d779efcdd95c32069739554ac1b2a150.jpg'
    },
    {
      name: 'Michael C.',
      role: 'Purchasing Manager, City Supermarket Chain',
      content: 'We switched to Green Choice Bag last year and couldn\'t be happier. The wholesale pricing is competitive, delivery is always on time, and the bags are durable enough for heavy grocery loads. Highly recommend!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Asian%20male%20business%20professional%20in%20his%20thirties%20with%20friendly%20expression%20wearing%20smart%20casual%20attire%20in%20contemporary%20office%20environment%2C%20natural%20portrait%20with%20soft%20focus%20background%2C%20professional%20headshot%20photography%20style&width=200&height=200&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Jennifer R',
      role: 'Operations Director, Organic Foods Co.',
      content: 'The customization options are fantastic. We were able to create bags that perfectly match our brand identity. The customer service team was helpful throughout the entire design process. Great partnership!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Hispanic%20female%20executive%20in%20her%20thirties%20with%20warm%20smile%20wearing%20professional%20business%20clothing%20in%20modern%20workspace%2C%20natural%20lighting%20portrait%20photography%20with%20blurred%20office%20background%2C%20authentic%20corporate%20headshot%20style&width=200&height=200&seq=testimonial-003&orientation=squarish'
    }
  ];

  const certifications = [
    {
      icon: 'ri-recycle-fill',
      title: 'FSC Certified',
      description: 'Forest Stewardship Council approved materials'
    },
    {
      icon: 'ri-leaf-fill',
      title: 'EPA Compliant',
      description: 'Meets environmental protection standards'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Quality Tested',
      description: 'Rigorous quality control processes'
    },
    {
      icon: 'ri-flag-fill',
      title: 'Made in USA',
      description: 'Proudly manufactured domestically'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#5a7c3e] mb-4">
            Trusted by Businesses Nationwide
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Join hundreds of satisfied retailers and grocery stores who trust Green Choice Bag for their packaging needs
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#f5f8f2] p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-bold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#5a7c3e] to-[#4a6c2e] rounded-2xl p-10 md:p-12">
          <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-white mb-3">
              Certifications &amp; Trust Signals
            </h3>
            <p className="text-white/90 text-base">
              Our commitment to quality and sustainability is backed by industry certifications
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${cert.icon} text-3xl text-white`}></i>
                </div>
                <h4 className="text-lg font-bold text-white mb-2">{cert.title}</h4>
                <p className="text-sm text-white/80">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
